import {
  provideHttpClient,
  withInterceptorsFromDi,
  HTTP_INTERCEPTORS,
} from '@angular/common/http';
import {
  ApplicationConfig,
  provideZoneChangeDetection,
  APP_INITIALIZER
} from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { provideRouter } from '@angular/router';
import { provideKeycloak } from 'keycloak-angular';

import { environment } from '../environments/environment';

import { routes } from './app.routes';

import { I18nService } from './core/services/i18n.service';
import { LoaderInterceptor } from './core/interceptors/loader.interceptor';
import { ToastInterceptor } from './core/interceptors/toast.interceptor';
import { AuthInterceptor } from './core/interceptors/auth.interceptor';
import { CorrelationIdInterceptor } from './core/interceptors/correlation-id.interceptor';
import { SvgIconsService } from './core/services/svg-icons.service';
import { AuthService } from './core/services/auth.service';

import { msalAppConfig } from '../msal-config';

import { AUTH_PROVIDER } from './core/auth/auth.provider';
import { authProviderFactory } from './core/auth/auth.factory';
import { AuthProviderType } from './core/auth/auth.constants';
import { PRODUCT_SOURCE } from './core/services/product-source/product-source';
import { ApiProductSource } from './core/services/product-source/api-product.source';

export const appConfig: ApplicationConfig = {
  providers: [

    provideZoneChangeDetection({
      eventCoalescing: true
    }),

    provideRouter(routes),

    provideHttpClient(withInterceptorsFromDi()),

    {
      provide: AUTH_PROVIDER,
      useFactory: authProviderFactory
    },

    // Product assignment: read from Auth/me (`insuranceProducts`).
    {
      provide: PRODUCT_SOURCE,
      useClass: ApiProductSource
    },

    ...(environment.auth.provider === AuthProviderType.Entra
      ? msalAppConfig.providers
      : []),

    ...(environment.auth.provider === AuthProviderType.Keycloak
      ? [
        provideKeycloak({
          config: {
            url: environment.auth.keycloak.baseUrl,
            realm: environment.auth.keycloak.realm,
            clientId: environment.auth.keycloak.clientId,
          },
        }),
      ]
      : []),

    I18nService,

    {
      provide: 'I18N_EAGER_INIT',
      useFactory: (i18n: I18nService) => {
        void i18n.init();
        return true;
      },
      deps: [I18nService],
    },

    {
      provide: APP_INITIALIZER,
      useFactory: (authService: AuthService) => {
        return () =>
          authService.initialize().catch((error) => {
            console.error(
              'Authentication initialization failed:',
              error
            );
            return Promise.resolve();
          });
      },
      deps: [AuthService],
      multi: true,
    },

    MatIconRegistry,

    SvgIconsService,

    {
      provide: HTTP_INTERCEPTORS,
      useClass: CorrelationIdInterceptor,
      multi: true,
    },

    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },

    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoaderInterceptor,
      multi: true,
    },

    {
      provide: HTTP_INTERCEPTORS,
      useClass: ToastInterceptor,
      multi: true,
    },
  ],
};